import React from 'react'
import { CircularProgress } from '@mui/material'
import FindInPageIcon from '@mui/icons-material/FindInPage'

import Colors from 'utils/Colors'
import { Button, Notification } from '../ResultBox/styles'

const OpenApplicationButton = ({
  application,
  onOpenDetails,
  reviewsSummary,
  loadingReviewsSummary,
}) => {
  const pendingReviews = reviewsSummary?.pending_for_user_area || 0

  const hasReviews = pendingReviews > 0

  const handleClick = () => {
    onOpenDetails(application)
  }

  // if (loading) {
  //   return (
  //     <LoadingContainer>
  //       <CircularProgress size="1.8rem" style={{ color: Colors.primaryColor }} />
  //     </LoadingContainer>
  //   )
  // }

  return (
    <Button
      id={application.uuid}
      onClick={handleClick}
      style={{
        backgroundColor: hasReviews ? Colors.blue : Colors.white,
        borderColor: hasReviews ? Colors.darkBlue : '#ddd',
        color: hasReviews ? Colors.white : '#676767',
      }}
    >
      { loadingReviewsSummary && <CircularProgress size="1.65rem" style={{ margin: '0 0.25rem', color: hasReviews ? Colors.white : Colors.primaryColor }} /> }
      { !loadingReviewsSummary && <FindInPageIcon fontSize="small" /> }
      <span>{hasReviews ? 'Revisar' : 'Detalhes'}</span>
      {hasReviews && <Notification>{pendingReviews}</Notification>}
    </Button>
  )
}

export default OpenApplicationButton
